<agreement-modal>
<div id="{ props.modalId }" class="modal">
  <div class="modal__bg"></div>
  <div class="modal__content">
    <div class="modal__content_inner">
      <h2 class="heading-01 heading_search">利用規約</h2>
      <div style="max-height:300px;overflow-y: scroll">
      <rules-content-tag></rules-content-tag>
      </div>
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          name="rule"
          id="rule"
          class="checkbox-input js-check"
          onclick="{ e=> onCheck(e) }"
        />
        <label for="rule" class="checkbox-parts">
          利用規約に同意する
        </label>
      </div>
      <div class="container_button">
        <button id="button" class="button button-primary button-primary-mini" type="button" value="登録する" onclick={props.agree} disabled>登録する</button>
      </div><!--/.container_button-->	
    </div><!--/.modal__content_inner-->
  </div><!--modal__content-->
</div><!--modal-->
<script>
  import di from "dependency-injection";
  import rulesTag from '@tags/parts/croco-desk-rules.riot';
  export default {
    components: {
      "rules-content-tag": rulesTag
    },
    onCheck(e){
      this.$('#button').disabled = !e.target.checked;
    },
    onBeforeMount(){
      this.props.MenuApi.on('agreement:openModal', ()=>{
        $(`#${this.props.modalId}`).show();
      });
      this.props.MenuApi.on('agreement:closeModal', ()=>{
        $(`#${this.props.modalId}`).hide();
      });
    }
  };
</script>
</agreement-modal>